import React from 'react';
import c from 'classnames';

import './style.scss';

const CaoPdfLinksOverview = (props) => {
  const { entities, className } = props;

  const classNames = c('CaoPdfLinks', 'CaoPdfLinks--Overview', className);

  const links = entities.toJS();

  if (links.length === 0) {
    return null;
  }

  return (
    <div className={classNames}>
      <ul className="CaoPdfLinks--Overview__list">
        {links.map(({ nid, langcode, title }) => {
          return (
            <li key={`node:${nid}:${langcode}`} className="CaoPdfLinks--Overview__list-item">
              <a
                className="icon-before icon-download icon-variant-4"
                href={`/${langcode}/print/pdf/node/${nid}`}
                target="_blank"
                rel="noreferrer noopener"
              >
                {title}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default CaoPdfLinksOverview;
